import { guaranteedInheritanceOutput } from './../services/GuaranteedInheritanceCalc';

const defaultInput = {
  clientAge: 55, // F5 70..90+
  housePrice: 400000,  // F7
  futureHousePricePct: "0.00", // G13, 0%.. 7%
  qualifyForEnhancedLtv: true,
  totalEquityReleased: 51000,
  years: 1
};

const updateInputOutput = ({ input, output }) => {
  return { input, output };
};

const output = guaranteedInheritanceOutput(defaultInput);
const initialState = updateInputOutput({ input: defaultInput, output });

export default function (state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_INPUT': {
      const {field, value} = action.payload;
      const input = { ...state.input, [field] : value };
      const output = guaranteedInheritanceOutput(input);
      updateInputOutput({ input, output });
      return { ...state, input, output};
    }
    default:
  }
  return state
};



// WEBPACK FOOTER //
// ./src/reducers/guaranteedInheritance.js